document.addEventListener("DOMContentLoaded", () => {
  var ItemNum = $(".cause-item").length;

  var causeSwiper = new Swiper(".cause-list", {
    slidesPerView: 4,
    spaceBetween: 15,
    grid: {
      rows: ItemNum / ItemNum,
    },
    pagination: {
      el: ".cause-pagination",
      clickable: true,
    },
    breakpoints: {
      769: {
        slidesPerView: 4,
        grid: {
          rows: ItemNum / ItemNum,
        },
      },
      501: {
        slidesPerView: 2,
        grid: {
          rows: ItemNum / 2,
        },
      },
      300: {
        slidesPerView: 1.3,
        grid: {
          rows: ItemNum / ItemNum,
        },
      },
    },
  });
});
